import * as React from "react";

const SvgComponent = ({ width = "22px", height = "19px", color = "#fff", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 19"
    fill="none"
    cursor="pointer"
    {...props}
  >
    <path
      d="M19.614 16.106c1.483-1.05 2.331-2.571 2.331-4.186 0-2.297-1.699-4.26-4.087-5.051C17.219 3.478 13.708.88 9.46.88 4.758.88.945 4.057.945 7.976c0 2.238 1.257 4.22 3.19 5.535.736.501-1.05 2.189-1.05 2.189s3.57-1.008 4.104-.886a10.153 10.153 0 0 0 3.09.221h.001c1.162 1.396 3.078 2.313 5.247 2.313.573 0 1.143-.065 1.67-.187.343 0 1.76.357 2.659.61l1.823.513-1.375-1.303c-.306-.29-.608-.677-.69-.875ZM5.144 9.234a1.332 1.332 0 1 1 0-2.664 1.332 1.332 0 0 1 0 2.664Zm8.63-2.662a1.332 1.332 0 1 1 0 2.661 1.332 1.332 0 0 1 0-2.662ZM9.46 9.233a1.331 1.331 0 1 1-.002-2.663 1.331 1.331 0 0 1 .002 2.663Zm9.2 6.731c-.014.178.035.367.12.554-.62-.152-1.277-.293-1.584-.293l-.188.019c-.48.111-.978.168-1.48.168-1.642 0-3.114-.597-4.12-1.537 3.76-.736 6.564-3.543 6.564-6.9 0-.025-.005-.049-.005-.073h.001c1.8.737 3.043 2.258 3.043 4.017 0 1.337-.738 2.607-2.023 3.484a.736.736 0 0 0-.328.56v.001Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;